/* eslint-disable react/jsx-one-expression-per-line */
import { MainLayout } from 'layouts'
import { isLkmDomain } from 'router/utils'
import { LK_DOMAIN, LKM_DOMAIN } from 'constants/domains'

import style from './PrivacyPolicy.module.scss'

export const PrivacyPolicy = () => {
  const cabinetDomain = isLkmDomain() ? LKM_DOMAIN : LK_DOMAIN
  const privacyPolicyUrl = `https://${cabinetDomain}/privacy-policy/`

  return (
    <MainLayout>
      <div className='container'>
        <section className={style.privacyPolicy}>
          <h1>Политика обработки персональных данных</h1>
          <div className={style.privacyPolicyBlock}>
            <h2>1 ОБЩИЕ ПОЛОЖЕНИЯ</h2>
            <p>
              1.1 Настоящая Политика обработки персональных данных (далее –
              Политика) определяет порядок и условия обработки персональных
              данных ООО «ДОРХАН» (далее – Оператор) при использовании сайта{' '}
              {cabinetDomain}, всех его поддоменов, а также иных сайтов
              Оператора.
            </p>
            <p>
              1.2 Политика разработана в соответствии с Конституцией Российской
              Федерации, Федеральным законом от 27.07.2006 № 152-ФЗ «О
              персональных данных» и иными нормативными правовыми актами
              Российской Федерации в области обработки и защиты персональных
              данных.
            </p>
            <p>
              1.3 Политика применяется ко всем персональным данным, которые
              Оператор получает от посетителей сайтов, пользователей, клиентов,
              потенциальных клиентов, представителей организаций, дилеров и иных
              лиц, взаимодействующих с Оператором посредством сайтов.
            </p>
            <p>
              1.4 Политика является общедоступным документом. Предоставление
              согласия на обработку персональных данных осуществляется
              Пользователем отдельно при заполнении соответствующей формы на
              сайте.
            </p>
            <p>
              1.5 Использование Пользователем сайта и его поддоменов означает
              согласие с настоящей Политикой и условиями обработки персональных
              данных. В случае несогласия Пользователь должен прекратить
              использование сайта.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>2 СВЕДЕНИЯ ОБ ОПЕРАТОРЕ</h2>
            <p>
              <>
                Полное наименование: Общество с ограниченной ответственностью
                «ДОРХАН»
                <br />
                Сокращённое наименование: ООО «ДОРХАН»
                <br />
                ИНН: 7731169654
                <br />
                КПП: 503201001
                <br />
                ОГРН: 1027739622932
                <br />
                Адрес места нахождения: 143002, Московская область, городской
                округ Одинцовский, село Акулово, улица Новая, дом 120, строение
                1, офис 531
                <br />
                Телефон: +7 495 933-24-33
                <br />
                Электронная почта для обращений по вопросам обработки
                персональных данных: info@doorhan.ru
                <br />
              </>
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>3 ОСНОВНЫЕ ПОНЯТИЯ</h2>
            <p>
              Персональные данные – любая информация, относящаяся прямо или
              косвенно к определённому или определяемому физическому лицу
              (субъекту персональных данных).
            </p>
            <p>
              Обработка персональных данных – любое действие или совокупность
              действий с персональными данными, совершаемых с использованием
              средств автоматизации или без их использования, включая сбор,
              запись, систематизацию, накопление, хранение, уточнение,
              извлечение, использование, передачу (в том числе предоставление,
              доступ), обезличивание, блокирование, удаление, уничтожение.
            </p>
            <p>
              Оператор – ООО «ДОРХАН», самостоятельно организующее обработку
              персональных данных, определяющее цели обработки, состав
              персональных данных и совершаемые с ними действия.
            </p>
            <p>
              Пользователь – физическое лицо, использующее сайты Оператора или
              направляющее Оператору сведения посредством размещённых на сайтах
              форм.
            </p>
            <p>
              Дилеры – юридические лица или индивидуальные предприниматели,
              состоящие с Оператором в дилерских отношениях, реализующие
              продукцию Оператора и оказывающие услуги по консультированию,
              расчёту стоимости, подготовке коммерческих предложений и продаже
              изделий конечным потребителям.
            </p>
            <p>
              Файлы cookie – небольшие фрагменты данных, сохраняемые браузером
              на устройстве Пользователя при посещении сайта.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>4 ПРИНЦИПЫ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
            <p>
              Оператор обрабатывает персональные данные на законной и
              справедливой основе и руководствуется следующими принципами:
            </p>
            <ul>
              <li>
                обработка осуществляется только для конкретных, заранее
                определённых и законных целей;
              </li>
              <li>
                не допускается обработка, несовместимая с целями сбора
                персональных данных;
              </li>
              <li>
                состав и объём данных соответствуют заявленным целям обработки;
              </li>
              <li>не допускается обработка избыточных персональных данных;</li>
              <li>
                обеспечиваются точность и актуальность персональных данных;
              </li>
              <li>
                персональные данные хранятся не дольше, чем этого требуют цели
                обработки или законодательство Российской Федерации;
              </li>
              <li>
                после достижения целей обработки данные уничтожаются или
                обезличиваются, если отсутствуют иные законные основания для их
                хранения.
              </li>
            </ul>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>5 ЦЕЛИ ОБРАБОТКИ И ПЕРЕЧЕНЬ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
            <p>5.1 Обработка обращений и заявок</p>
            <p>
              Категории субъектов: посетители сайтов, потенциальные клиенты,
              клиенты, дилеры, представители организаций и иные лица,
              направляющие обращения Оператору.
            </p>
            <p>Цели обработки:</p>
            <ul>
              <li>
                обработка обращений и заявок (в том числе через формы
                «Купить/Оставить заявку», «Задать вопрос специалисту», «Стать
                дилером», «Письмо директору», «Оставить отзыв», «Регистрация на
                форуме», «Рассчитать стоимость», «Получить коммерческое
                предложение»);
              </li>
              <li>предоставление ответов и консультаций;</li>
              <li>подготовка коммерческих предложений;</li>
              <li>подбор товаров и услуг;</li>
              <li>обработка заявок на дилерское сотрудничество;</li>
              <li>обработка отзывов, вопросов и обращений к руководству;</li>
              <li>установление и поддержание обратной связи.</li>
            </ul>
            <p>Перечень обрабатываемых данных:</p>
            <ul>
              <li>фамилия, имя и отчество;</li>
              <li>номер телефона;</li>
              <li>адрес электронной почты;</li>
              <li>город и регион;</li>
              <li>адрес для корреспонденции;</li>
              <li>адрес или место предполагаемой установки продукции;</li>
              <li>наименование организации;</li>
              <li>должность;</li>
              <li>
                содержание обращения и иные сведения, добровольно указанные
                Пользователем.
              </li>
            </ul>
            <p>
              Правовые основания: согласие субъекта персональных данных,
              необходимость совершения действий по запросу субъекта до
              заключения договора, заключение и исполнение договора, а также
              иные основания, предусмотренные законодательством РФ.
            </p>
            <p>
              Срок обработки: до завершения рассмотрения обращения, достижения
              соответствующей цели или отзыва согласия, но не более 3 лет с
              момента последнего взаимодействия, если иное не требуется для
              исполнения договора или законодательства.
            </p>
            <p>5.1 Заключение и исполнение договоров</p>
            <p>
              Категории субъектов: клиенты, заказчики, покупатели, контрагенты и
              представители юридических лиц.
            </p>
            <p>Цели обработки:</p>
            <ul>
              <li>подготовка, заключение и исполнение договоров;</li>
              <li>оформление заказов;</li>
              <li>доставка товаров и оказание услуг;</li>
              <li>ведение бухгалтерского и налогового учёта;</li>
              <li>
                исполнение требований законодательства Российской Федерации.
              </li>
            </ul>
            <p>
              Перечень данных: фамилия, имя, отчество, номер телефона, адрес
              электронной почты, адрес доставки или установки, сведения об
              организации, должность, сведения о заказе, договоре и расчётах,
              реквизиты банковских карт (обрабатываются транзакционно через
              защищённые шлюзы без хранения на стороне Оператора).
            </p>
            <p>
              Срок обработки: в течение срока действия договора и установленных
              законодательством сроков хранения бухгалтерских, налоговых и иных
              обязательных документов, но не менее 5 лет для договорных
              документов.
            </p>
            <p>5.3. Работа сайта, безопасность и статистика</p>
            <p>
              Категории субъектов: посетители и пользователи сайтов Оператора.
            </p>
            <p>Цели обработки:</p>
            <ul>
              <li>обеспечение работоспособности и безопасности сайтов;</li>
              <li>предотвращение злоупотреблений и неправомерных действий;</li>
              <li>диагностика и устранение технических ошибок;</li>
              <li>анализ посещаемости и использования сайтов;</li>
              <li>улучшение структуры, содержания и удобства сайтов.</li>
            </ul>
            <p>Обрабатываемые технические данные:</p>
            <ul>
              <li>IP-адрес;</li>
              <li>файлы cookie;</li>
              <li>тип и версия браузера;</li>
              <li>тип устройства и операционная система;</li>
              <li>адрес посещённой страницы;</li>
              <li>источник перехода;</li>
              <li>дата и время посещения;</li>
              <li>сведения о действиях Пользователя на сайте;</li>
              <li>технические идентификаторы и параметры сессии.</li>
            </ul>
            <p>
              Срок обработки: в течение срока, необходимого для обеспечения
              работы и безопасности сайтов, проведения статистического анализа,
              но не более 3 лет с момента последнего посещения.
            </p>
            <p>5.4. Информационные и рекламные сообщения</p>
            <p>
              Оператор может направлять Пользователю информационные и рекламные
              сообщения по электронной почте или телефону только при наличии
              отдельного предварительного согласия Пользователя.
            </p>
            <p>
              Для рассылки обрабатываются имя, номер телефона и адрес
              электронной почты.
            </p>
            <p>
              Пользователь может в любое время отказаться от рассылки по ссылке,
              содержащейся в сообщении, либо направив требование на адрес
              info@doorhan.ru. После получения отказа направление рекламных
              сообщений прекращается.
            </p>
            <p>5.5. Размещение отзывов</p>
            <p>
              Если отзыв Пользователя предполагается разместить в открытом
              доступе с указанием имени, изображения, организации или иных
              персональных данных, Оператор получает отдельное согласие на
              обработку персональных данных, разрешённых субъектом для
              распространения.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>6 ДЕЙСТВИЯ С ПЕРСОНАЛЬНЫМИ ДАННЫМИ</h2>
            <p>
              Оператор может осуществлять следующие действия с персональными
              данными: сбор, запись, систематизация, накопление, хранение,
              уточнение (обновление, изменение), извлечение, использование,
              передача (в форме предоставления или доступа), обезличивание,
              блокирование, удаление, уничтожение.
            </p>
            <p>
              Обработка осуществляется с использованием средств автоматизации,
              без использования таких средств либо смешанным способом.
            </p>
            <p>
              Оператор не принимает решений, порождающих юридические последствия
              для Пользователя, исключительно на основании автоматизированной
              обработки персональных данных.
            </p>
            <p>
              Специальные категории персональных данных и биометрические
              персональные данные посредством сайтов не обрабатываются.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>7 ФАЙЛЫ COOKIE И ЯНДЕКС.МЕТРИКА</h2>
            <p>
              Сайты используют необходимые файлы cookie для обеспечения работы
              страниц, форм, функций безопасности и сохранения пользовательской
              сессии.
            </p>
            <p>
              Аналитические и иные необязательные файлы cookie используются
              после получения согласия Пользователя посредством уведомления или
              панели управления cookie.
            </p>
            <p>
              Для анализа посещаемости сайтов Оператор использует сервис
              Яндекс.Метрика, предоставляемый ООО «ЯНДЕКС» (Россия). При
              использовании Яндекс.Метрики могут обрабатываться IP-адрес, файлы
              cookie, сведения об устройстве, браузере, операционной системе,
              посещённых страницах, источнике перехода, дате и времени
              посещения, а также действиях Пользователя на сайте. ООО «ЯНДЕКС»
              осуществляет обработку указанных данных по поручению Оператора в
              целях предоставления статистической информации.
            </p>
            <p>
              Пользователь может ограничить или запретить использование файлов
              cookie в настройках своего браузера. Ограничение необходимых
              файлов cookie может привести к некорректной работе отдельных
              функций сайтов.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>8 ПЕРЕДАЧА ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
            <p>
              8.1. Оператор не распространяет персональные данные и не
              предоставляет к ним неограниченный доступ без отдельного согласия
              субъекта персональных данных или иного законного основания.
            </p>
            <p>8.2. Персональные данные могут быть предоставлены:</p>
            <ul>
              <li>
                лицам, обрабатывающим данные по поручению Оператора (на
                основании договоров поручения);
              </li>
              <li>
                поставщикам хостинга, программного обеспечения, связи и
                технической поддержки (при условии, что они обеспечивают
                конфиденциальность);
              </li>
              <li>
                официальным дилерам DoorHan, выбранным с учётом региона и
                содержания обращения, для обработки заявки, консультирования,
                расчёта стоимости, подготовки коммерческого предложения и
                последующей продажи изделий Пользователю;
              </li>
              <li>
                службам доставки и иным подрядчикам, участвующим в исполнении
                обращения или договора;
              </li>
              <li>
                государственным органам в случаях и порядке, предусмотренных
                законодательством Российской Федерации.
              </li>
            </ul>
            <p>
              8.3. Передача данных дилерам осуществляется исключительно в целях,
              предусмотренных п. 5.1 настоящей Политики, и только при наличии в
              договоре с дилером обязательств по обеспечению конфиденциальности
              и безопасности полученных персональных данных, а также
              использованию их исключительно для указанных целей.
            </p>
            <p>
              8.4. Перечень дилеров, которым передаются данные, может быть
              запрошен у Оператора по электронной почте info@doorhan.ru.
            </p>
            <p>
              8.5. Оператор обязан обеспечить, чтобы все дилеры, которым
              передаются персональные данные, принимали обязательства по их
              конфиденциальности и использовали их исключительно для целей,
              указанных в п. 5.1.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>9 ПЕРЕДАЧА ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
            <p>
              9.1. При сборе персональных данных граждан Российской Федерации
              запись, систематизация, накопление, хранение, уточнение и
              извлечение персональных данных осуществляются с использованием баз
              данных, находящихся на территории Российской Федерации.
            </p>
            <p>
              9.2. Сроки обработки и хранения определяются целями обработки,
              условиями согласия, сроками действия договоров и требованиями
              законодательства Российской Федерации:
            </p>
            <ul>
              <li>
                для договорных данных – 5 лет с момента окончания договора (в
                соответствии с налоговым и бухгалтерским законодательством);
              </li>
              <li>
                для маркетинговых целей – до отзыва согласия Пользователем;
              </li>
              <li>
                для иных целей – не более 1 года с момента последнего
                взаимодействия, если иное не предусмотрено законом.
              </li>
            </ul>
            <p>
              9.3. После достижения целей обработки либо утраты необходимости в
              обработке данные уничтожаются или обезличиваются в течение 30
              календарных дней, если их дальнейшее хранение не требуется в
              соответствии с законодательством или договором.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>10 ЗАЩИТА ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
            <p>
              Оператор принимает необходимые правовые, организационные и
              технические меры для защиты персональных данных, в том числе:
            </p>
            <ul>
              <li>
                назначает лицо, ответственное за организацию обработки
                персональных данных;
              </li>
              <li>
                принимает локальные документы по вопросам обработки и защиты
                персональных данных;
              </li>
              <li>ограничивает доступ работников к персональным данным;</li>
              <li>
                использует средства защиты информации и контроля доступа
                (включая шифрование каналов связи SSL/TLS);
              </li>
              <li>
                осуществляет резервное копирование и восстановление данных;
              </li>
              <li>
                выявляет и устраняет нарушения при обработке персональных
                данных;
              </li>
              <li>контролирует эффективность применяемых мер защиты;</li>
              <li>
                проводит внутренний контроль соответствия обработки требованиям
                законодательства.
              </li>
            </ul>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>11 ПРАВА СУБЪЕКТА ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
            <p>Субъект персональных данных вправе:</p>
            <ul>
              <li>
                получать информацию об обработке своих персональных данных, в
                том числе о целях, способах, сроках и третьих лицах (включая
                дилеров);
              </li>
              <li>
                требовать уточнения, блокирования или уничтожения неточных,
                устаревших, незаконно полученных или не требующихся данных;
              </li>
              <li>
                отозвать согласие на обработку персональных данных (за
                исключением случаев, когда обработка продолжается на ином
                законном основании, например, для исполнения договора);
              </li>
              <li>потребовать прекращения обработки персональных данных;</li>
              <li>отказаться от получения рекламных сообщений;</li>
              <li>
                обжаловать действия или бездействие Оператора в Роскомнадзоре
                или в судебном порядке;
              </li>
              <li>
                осуществлять иные права, предусмотренные законодательством
                Российской Федерации.
              </li>
            </ul>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>12 ОБРАЩЕНИЯ ПОЛЬЗОВАТЕЛЕЙ</h2>
            <p>
              Для реализации своих прав Пользователь может направить Оператору
              обращение:
            </p>
            <ul>
              <li>по электронной почте: info@doorhan.ru;</li>
              <li>
                по почтовому адресу: 143002, Московская область, городской округ
                Одинцовский, село Акулово, улица Новая, дом 120, строение 1,
                офис 531.
              </li>
            </ul>
            <p>
              Обращение должно позволять идентифицировать заявителя и содержать
              описание его требования. При необходимости Оператор вправе
              запросить сведения, подтверждающие личность заявителя и его
              отношение к обрабатываемым данным.
            </p>
            <p>
              Оператор рассматривает обращения и предоставляет ответ в срок не
              более 10 рабочих дней с момента получения запроса.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>13 ПРЕКРАЩЕНИЕ ОБРАБОТКИ И УНИЧТОЖЕНИЕ ДАННЫХ</h2>
            <p>
              13.1. Оператор прекращает обработку персональных данных при
              достижении целей обработки, истечении срока действия или отзыве
              согласия, поступлении законного требования субъекта либо выявлении
              неправомерной обработки, если отсутствуют другие законные
              основания для продолжения обработки.
            </p>
            <p>
              13.2. При поступлении требования о прекращении обработки Оператор
              прекращает обработку в срок, установленный законодательством (не
              более 10 рабочих дней), за исключением случаев, когда обработка
              может быть продолжена на другом законном основании (например, для
              исполнения договора).
            </p>
            <p>
              13.3. При достижении целей обработки или отзыве согласия
              персональные данные уничтожаются в срок, не превышающий 30 дней,
              если их дальнейшее хранение не требуется в соответствии с
              законодательством или договором.
            </p>
            <p>
              13.4. В случае, если персональные данные были переданы дилерам,
              Оператор обязан уведомить соответствующих дилеров о необходимости
              уничтожения таких данных, если они более не требуются для
              достижения целей обработки, а также по требованию Пользователя.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>14 ТРАНСГРАНИЧНАЯ ПЕРЕДАЧА ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
            <p>
              Оператор НЕ ОСУЩЕСТВЛЯЕТ трансграничную передачу персональных
              данных Пользователей.
            </p>
            <p>
              Все персональные данные обрабатываются и хранятся исключительно на
              серверах, расположенных на территории Российской Федерации, в
              соответствии с требованиями Федерального закона от 27.07.2006 №
              152-ФЗ «О персональных данных». Передача данных каким-либо
              иностранным лицам или на территорию иностранных государств не
              производится.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>15 ОТВЕТСТВЕННОСТЬ</h2>
            <p>
              15.1. Оператор несёт ответственность за убытки, понесённые
              Пользователем в связи с неправомерным использованием персональных
              данных, в соответствии с законодательством РФ, за исключением
              случаев, когда данные стали общедоступными до их разглашения, были
              получены от третьей стороны или разглашены с согласия
              Пользователя.
            </p>
            <p>
              15.2. Оператор освобождается от ответственности, если докажет, что
              нарушение обязательств произошло вследствие непреодолимой силы или
              действий третьих лиц, не связанных с Оператором.
            </p>
            <p>
              15.3. Оператор не несёт ответственности за действия дилеров, если
              дилеры использовали полученные персональные данные не в целях,
              предусмотренных настоящей Политикой, или нарушили взятые на себя
              обязательства по конфиденциальности, при условии, что Оператор
              надлежащим образом осуществил контроль за соблюдением таких
              обязательств на момент передачи данных.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>16 РАЗРЕШЕНИЕ СПОРОВ</h2>
            <p>
              16.1. До обращения в суд по спорам между Пользователем и
              Оператором обязательным является предъявление претензии в
              письменной форме.
            </p>
            <p>
              16.2. Оператор рассматривает претензию в течение 10 рабочих дней с
              момента её получения.
            </p>
            <p>
              16.3. При недостижении соглашения спор передаётся на рассмотрение
              в суд в соответствии с действующим законодательством РФ (по месту
              нахождения Оператора).
            </p>
            <p>
              16.4. К настоящей Политике и отношениям сторон применяется
              действующее законодательство Российской Федерации.
            </p>
          </div>
          <div className={style.privacyPolicyBlock}>
            <h2>17 ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h2>
            <p>
              17.1. Оператор вправе вносить изменения в настоящую Политику при
              изменении законодательства, состава обрабатываемых данных,
              используемых информационных систем или порядка обработки
              персональных данных. Изменения вступают в силу не ранее чем через
              7 календарных дней после публикации новой редакции на сайте.
            </p>
            <p>
              17.2. Новая редакция Политики вступает в силу с момента её
              размещения на сайте, если иной срок не указан в новой редакции.
            </p>
            <p>
              17.3. Актуальная редакция Политики постоянно размещена по адресу:{' '}
              {privacyPolicyUrl}.
            </p>
            <p>
              17.4. Ответственное лицо за организацию обработки персональных
              данных – ФИО, должность, контактный телефон и email
              предоставляются по запросу Пользователя.
            </p>
          </div>
        </section>
      </div>
    </MainLayout>
  )
}
